module.exports = __webpack_public_path__ + "static/media/policy_question.87910fe9.mp3";